import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openSettingsSubmenu } from '../sidebarHelpers';

const addDNSRecords = (baseUrl, navigate, verificationStatus) => {
  return {
    id: 'addDNSRecords',
    title: 'Add your DKIM and click tracking DNS records',
    steps: [
      {
        selector: '[data-tour="settingsLink"]',
        content: <p>Click on the "Settings" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openSettingsSubmenu('[data-tour="messagingSettingsLink"]'),
        id: 'goToShopSettings',
        selector: '[data-tour="messagingSettingsLink"]',
        content: (
          <p>
            In this section, you can find general settings about your shop like, email settings, subscription
            management, and much more.
          </p>
        ),
      },
      {
        id: 'goToShopSettingsGeneral',
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/settings/messagingAndAds`, true);
        },
        selector: '[data-tour="shopSettingsGeneralTab"]',
        content: (
          <>
            <p>
              In this tab, you can set up the email sender name, address, and the reply-to address which will receive
              any replies from your contacts.
            </p>
            <p>
              You can also define how many emails your users can receive in a day. We recommend keeping this setting
              lower than 4.
            </p>
          </>
        ),
      },
      {
        id: 'checkEmailSenderVerification',
        actionBefore: () => navigate(`${baseUrl}/settings/messagingAndAds?tab=emails`, true),
        selector: '[data-tour="emailDnsVerificationLink"]',
        content: (
          <>
            <p>Click on details in the email sender verification section.</p>
          </>
        ),
      },
      {
        id: 'copyEmailSenderDkimRecord',
        actionBefore: () => navigate(`${baseUrl}/settings/messagingAndAds?tab=emails&emailDnsVerificationOpen=1`),
        selector: '[data-tour="emailVerificationDKIMRecords"]',
        content: <p>Copy this DKIM record and paste it into your domain's DNS settings.</p>,
        stepInteraction: true,
      },
      {
        id: 'copyEmailSenderClickTrackingRecord',
        selector: '[data-tour="emailVerificationMainRecord"]',
        content: <p>Copy this click tracking record and paste it into your domain's DNS settings too.</p>,
        stepInteraction: true,
      },
      {
        id: 'backToTour',
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!verificationStatus?.isEmailSendingVerified,
  };
};

export default addDNSRecords;
